import { SearchObject } from "app/common/Model/SearchObject";
import {
  exportExcelMedicalEquipmentUsageReport,
  searchMedicalEquipmentUsageReport,
} from "app/services/ReportService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";

export default class MedicalEquipmentUsageReportStore {
  intactSearchObject = {
    ...new SearchObject(),
    fromDate: new Date(),
    toDate: new Date(),
    department: null,
    departmentIds: [],
    equipmentIds: [],
    serviceIds: [],
    roomIds: [],
    keyword: "",
    reportType: 0,
  };

  searchObject = JSON.parse(JSON.stringify(this.intactSearchObject));
  pageData = null;

  constructor() {
    makeAutoObservable(this);
  }

  normalizeSearch = (rawSearch = {}) => {
    const {
      department,
      departmentIds,
      equipmentIds,
      serviceIds,
      roomIds,
      ...rest
    } = rawSearch;

    const normalizedDepartmentIds =
      departmentIds?.length > 0
        ? departmentIds.map((item) => item?.id || item).filter(Boolean)
        : department?.id
          ? [department.id]
          : null;

    return {
      ...rest,
      departmentIds: normalizedDepartmentIds,
      equipmentIds:
        equipmentIds?.length > 0
          ? equipmentIds.map((item) => item?.id || item).filter(Boolean)
          : null,
      serviceIds:
        serviceIds?.length > 0
          ? serviceIds.map((item) => item?.id || item).filter(Boolean)
          : null,
      roomIds:
        roomIds?.length > 0
          ? roomIds.map((item) => item?.id || item).filter(Boolean)
          : null,
    };
  };

  fetchReport = async () => {
    try {
      const { data } = await searchMedicalEquipmentUsageReport(
        this.normalizeSearch(this.searchObject)
      );
      this.pageData = data;
    } catch (error) {
      console.error(error);
      toast.error("Lấy dữ liệu báo cáo thiết bị có lỗi");
    }
  };

  handleChangeFormSearch = (values) => {
    this.searchObject = {
      ...this.searchObject,
      ...values,
      pageIndex: values?.pageIndex || 1,
    };
    this.fetchReport();
  };

  handleChangePage = (pageIndex) => {
    this.handleChangeFormSearch({ pageIndex });
  };

  handleChangePageSize = (pageSize) => {
    this.handleChangeFormSearch({ pageSize, pageIndex: 1 });
  };

  handleChangeReportType = (reportType) => {
    this.handleChangeFormSearch({ reportType, pageIndex: 1 });
  };

  handleExportExcel = async () => {
    try {
      const response = await exportExcelMedicalEquipmentUsageReport(
        this.normalizeSearch(this.searchObject)
      );
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "BAO_CAO_THIET_BI_SU_DUNG.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        toast.success("Xuất excel thành công");
      }
    } catch (error) {
      console.error(error);
      toast.error("Xuất excel báo cáo thiết bị có lỗi");
    }
  };

  resetStore = () => {
    this.searchObject = JSON.parse(JSON.stringify(this.intactSearchObject));
    this.pageData = null;
  };
}
